var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('div',{staticClass:"text-center text-secondary"},[_vm._t("icon",function(){return [_c('img',{attrs:{"src":"/static/images/worker.png","alt":"Worker"}})]}),_vm._t("default",function(){return [_c('h1',[_vm._v("Este seccion esta en construccion.")])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }